import React from 'react'
import { Link } from 'react-router-dom'
import { history } from '../helpers'


import '../styles/UrlInput.min.css'

class UrlInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      url: ''
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    history.push(`${process.env.PUBLIC_URL}/article/${encodeURIComponent(this.state.url)}`)
  }

  render() {
    return (
      <form className="form" onSubmit={this.handleSubmit}>
        <input name="url"
               type="text"
               value={this.state.url}
               onChange={this.handleInputChange}
               placeholder="Enter URL from https://www.chicagotribune.com"
               required />
        <Link to={`${process.env.PUBLIC_URL}/article/${encodeURIComponent(this.state.url)}`} className="button">Access Article</Link>
      </form>
    )
  }
}

export default UrlInput
